/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";

interface ExtendedTileLayerOptions extends L.TileLayerOptions {
  xOffset?: number;
  yOffset?: number;
}

interface TilePoint {
  s?: string;
  z: number;
  x: number;
  y: number;
}

(L as any).ExtendedTileLayer = (L.TileLayer as any).extend({
  options: {
    xOffset: 0,
    yOffset: 0,
    minZoom: 2,
    maxNativeZoom: 20,
    maxZoom: 22,
  },

  getTileUrl: function (tilePoint: TilePoint): string {
    return L.TileLayer.prototype.getTileUrl.call(this, {
      s: tilePoint.s,
      z: tilePoint.z,
      x: tilePoint.x + this.options.xOffset,
      y: tilePoint.y + this.options.yOffset,
    });
  },
});

export const extendedTileLayer = function (
  url: string,
  options?: ExtendedTileLayerOptions
): any {
  return new (L as any).ExtendedTileLayer(url, options);
};

export const extendedTileLayerxtends = (L as any).extendedTileLayer;
